import { useParams, useLocation, useNavigate } from "react-router";
import { useEffect, useRef } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";
import { useNotification } from "@refinedev/core";
import { useQueryClient } from "@tanstack/react-query";

import { productSchema, ProductFormValues } from "@modules/defaultProducts/validations/productSchema";
import { useUpdateProductMutation } from "@modules/defaultProducts/services/mutations";

export function useProductEditForm() {
  const { id } = useParams();
  const location = useLocation() as any;
  const navigate = useNavigate();
  const { open } = useNotification();
  const queryClient = useQueryClient();
  
  const { mutateAsync, isPending } = useUpdateProductMutation(Number(id), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"], refetchType: "all" });
      open?.({ type: "success", message: "Produto atualizado com sucesso" });
      navigate("/products");
    },
    onError: () => {
      open?.({ type: "error", message: "Erro ao atualizar produto" });
    },
  });

  const methods = useForm<ProductFormValues>({
    resolver: zodResolver(productSchema()),
    defaultValues: {
      name: "",
      is_bookstore: false,
      is_superapp: false,
      create_landing: false,
      active: true,
      metadata: {},
    },
    mode: "onBlur",
  }); 

  // hydrate from navigation state once (mock edit)
  const productFromState = location?.state?.product;
  const initializedRef = useRef(false);
  useEffect(() => {
    if (!initializedRef.current && productFromState) {
      methods.reset({
        name: productFromState.name ?? "",
        is_bookstore: productFromState.is_bookstore ?? false,
        is_superapp: productFromState.is_superapp ?? false,
        create_landing: productFromState.create_landing ?? false,
        active: productFromState.active ?? true,
        metadata: productFromState.metadata ?? {},
      });
      initializedRef.current = true;
    }
  }, [productFromState, methods]);

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}


